import { FC, HTMLAttributes } from "react";
import { ElContainer } from "./container.css";
import { cx } from "@linaria/core";

interface IContainerProps extends HTMLAttributes<HTMLElement> {}

export const Container: FC<IContainerProps> = ({ children, ...props }) => {
  return (
    <ElContainer {...props} className={cx("container", props.className)}>
      {children}
    </ElContainer>
  );
};
